<template>
    <v-container max-width="100%" style="margin-top: 2%">

      <template>
      <v-row justify="center">
        <v-dialog
          v-model="progressoDialog"
          persistent
          max-width="500"
          style="height: 300px; z-index: 90000"
        >
          <v-card>
            <v-card-text>
              <v-row justify="center">
                <h3 style="margin-top: 20px; color: #1565c0">
                  {{ this.mensagemProgressoDialog }}
                </h3>
              </v-row>

              <v-row justify="center">
                <v-progress-circular
                  :size="50"
                  :width="5"
                  color="primary"
                  indeterminate
                  style="margin-top: 10px; margin-bottom: 10px"
                ></v-progress-circular>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  
    <v-container class="toolbar__container">
          <v-form ref="form" v-model="formValidado">
            <v-row>
              <v-col cols="12" sm="12" md="5">
                <v-autocomplete
                  v-model="idFuncionariosSelected"
                  :items="funcionariosSelect"
                  item-text="descricao"
                  item-value="matricula"
                  clearable
                  multiple
                  :label="$tc('employee.self', 2)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="3">
                <v-datetime-picker
                  :label="$t('datetime.startDate')"
                  v-model="dti"
                  :time-picker-props="timeProps"
                  :text-field-props="textFieldProps"
                  :date-picker-props="dtiProps"
                  time-format="HH:mm:ss"
                  date-format="dd/MM/yyyy"
                  :clear-text="$t('datetime.close')"
                >
                  <template slot="dateIcon">
                    <v-icon>mdi-calendar</v-icon>
                  </template>
                  <template slot="timeIcon">
                    <v-icon>mdi-clock</v-icon>
                  </template>
                </v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-datetime-picker
                :label="$t('datetime.finalDate')"
                v-model="dtf"
                :time-picker-props="timeProps"
                :text-field-props="textFieldProps"
                :date-picker-props="dtfProps"
                time-format="HH:mm:ss"
                date-format="dd/MM/yyyy"
                :clear-text="$t('datetime.close')"
              >
                <template slot="dateIcon">
                  <v-icon>mdi-calendar</v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-clock</v-icon>
                </template>
              </v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="4" md="1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    fab
                    color="primary darken-1"
                    class="white--text"
                    v-bind="attrs"
                    v-on="on"
                    @click="populaRelatorio"
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('operation.search') }}</span>
              </v-tooltip>
            </v-col>
            </v-row>
          </v-form>
        </v-container>
  
  <div ref="pdfdiv">
    <merus-data-table
        :headers="headers"
        :items="servicosFiltered"
        sort-by="nome"
        dense
        class="elevation-7"
        locale="pt"
        :loading="loading"
        :loading-text="$t('system.messages.loading')"
        style="border-radius: 10px; margin-bottom: 10px; margin-top: 10px"
      >
        <template v-slot:toolbar>
            <CadastroToolbar
              :title="$t('nav.reports.timeBetweenTripsByService')"
              :token="token"
              :items="servicosFiltered"
              csv-title="tempodeplacaservico"
              :pdf-title="$t('nav.reports.timeBetweenTripsByService')"
              :pdf-headers="headers"
              pdf-filename="tempodeplacaservico"
              hide-search
            />
        </template>
      </merus-data-table>
    </div>
    </v-container>
  </template>
  
  <script>

  import apiController from "@/utils/apiController";
  import MerusDataTable from "./Tables/MerusDataTable.vue";
  import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
  import DateUtils from "../utils/dateutils";

  export default {
    components: {
    MerusDataTable,
    CadastroToolbar
},
    data: () => ({
      user: null,
      token: null,
      progressoDialog: false,
      showConfirmButton: true,
      mensagemProgressoDialog: "",
      formValidado: false,
      loading: false,
      timeProps: {
        useSeconds: true,
      },
      dti: null,
      dtf: null,
      idFuncionariosSelected: [],
      servicos: [],
      funcionariosSelect: [],
      config: null,
    }),
    computed: {
      headers() {
        return [
          { text: this.$t('relTimePlate.headers.id'), value: 'matricula', sortable: true, filtrable: true, show: true },
          { text: this.$t('relTimePlate.headers.name'), value: 'nome', sortable: true, filtrable: true, show: true },
          { text: this.$t('relTimePlate.headers.vehicle'), value: 'numero_ordem', sortable: true, filtrable: true, show: true },
          { text: this.$t('relTimePlate.headers.start'), value: 'inicio_servico_extenso', sortable: true, filtrable: true, show: true },
          { text: this.$t('relTimePlate.headers.end'), value: 'fim_servico_extenso', sortable: true, filtrable: true, show: true },
          { text: this.$t('relTimePlate.headers.serviceTime'), value: 'tempo_servico', sortable: true, filtrable: true, show: true },
          { text: this.$t('relTimePlate.headers.plateTime'), value: 'tempo_placa_total', sortable: true, filtrable: true, show: true },
        ];
      },
      textFieldProps() {
        return {
          prependInnerIcon: "mdi-calendar",
          rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
        }
      },
      headersWithProperties() {
        return this.headers.map(header => ({
          ...header,
          filtrable: true,
          sortable: true
        }));
      },
      servicosFiltered() {
        return this.servicos;
      },
      yesterday() {
        let td = new Date();
        td.setDate(td.getDate() - 1);
        return td.toISOString().substring(0,10);
      },
      dtiProps() {
        return {
          max: this.yesterday
        }
      },
      dtfProps() {
        let min = null;
        if (this.dti) {
          if (typeof this.dti === 'string') {
            min = `${this.dti.substring(6,10)}-${this.dti.substring(3,5)}-${this.dti.substring(0,2)}`;
          } else {
            min = this.dti.toISOString().substring(0,10);
          }
        }
        return {
          min: min
        }
      }
    },
    watch: {
      '$i18n.locale'() {
        this.initialize();
      }
    },
    created() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      this.token = sessionStorage.getItem("api");
      this.initialize();
    },
    mounted() {},
    methods: {
      initialize() {
        this.getConfig();
        this.populaFuncionarios();
      },
      getConfig() {
          apiController.request(apiController.endpoints.getallConfig, {
              onSuccess: (response) => {
                  this.config = response.data[0];
                  [this.dti, this.dtf] = DateUtils.setDefaultDateFiltersYesterday(this.config.hora_inicial_dia_operacao);
              },
          });
        },
      populaFuncionarios() {
        apiController.request(apiController.endpoints.getallFuncionarios, {
          onSuccess: (response) => {
            this.funcionariosSelect = response.data;
          },
        });
      },
      populaServicos() {
        this.loading = true;
        let dataInicial = DateUtils.getDateSQLFormatted(this.dti);
        let dataFinal = DateUtils.getDateSQLFormatted(this.dtf);

        if (this.idFuncionariosSelected.length > 0) {
          let temp = {
            matriculas: this.idFuncionariosSelected,
            dti: dataInicial,
            dtf: dataFinal
          }

          apiController.request(apiController.endpoints.getTempoplacatotalservicopormatricula, {
            data: temp,
            onSuccess: (response) => {
              this.servicos = response.data;
              this.loading = false;
            },
            onError: () => {
              this.loading = false;
            },
          });
        } else {
          apiController.request(apiController.endpoints.getTempoplacatotalservico, {
            params: { dti: dataInicial, dtf: dataFinal },
            onSuccess: (response) => {
              this.servicos = response.data;
              this.loading = false;
            },
            onError: () => {
              this.loading = false;
            },
          });
          }
        },
      populaRelatorio() {
        if (!this.$refs.form) {
          return;
        }
        // Usar o retorno de validate(): o v-model formValidado pode não atualizar no mesmo tick.
        const valid = this.$refs.form.validate();
        if (valid) {
          this.servicos = [];
          this.populaServicos();
          this.$nextTick(() => {
            this.$refs.form.resetValidation();
          });
        }
      },
    },
  };
  </script>